export default __webpack_public_path__ + "static/media/cloud-upload.25bbfac7.svg";